module.exports = __webpack_public_path__ + "static/media/shortinglistup-white.8e11f06a.svg";